import { useState, useEffect } from "react";
import { Row, Col, Tabs, Button, Input, Space, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined, CheckOutlined } from "@ant-design/icons";

import DataTable from "../DataTable";
import { AddAddonModal } from "../ModalForm";
import { EditAddonModal } from "../ModalForm";
import { searchAddonsApi } from "../../services/Addon/AddonApis";

const { TabPane } = Tabs;
const { Search } = Input;

interface IAddonProps {
  addons: any;
  groupId: string;
  handleAdd: Function;
  handleUpdate: Function;
  handleDelete: Function;
}

const AddonTable: React.FC<IAddonProps> = ({
  addons,
  groupId,
  handleAdd,
  handleUpdate,
  handleDelete,
}) => {
  const [active, setActive] = useState([]); //All Tab
  const [inactive, setInactive] = useState([]); //Cancelled Tab
  const [filtered, setFiltered] = useState<any[]>([]);
  const [filteredActive, setFilteredActive] = useState<any[]>([]);
  const [filteredInActive, setFilteredInActive] = useState<any[]>([]);
  const [addon, setAddon] = useState({});
  const [update, setUpdate] = useState(false);
  const [show, setShow] = useState(false);
  const [state, setState] = useState({
    loading: true,
    activeKey: "1",
    pagination: {
      pageSize: 15,
      position: ["bottomRight"],
      total: 0,
      current: 1,
      hideOnSinglePage: true,
    },
    searchItem: "",
  });

  const showModal = () => {
    setShow(!show);
    setUpdate(false);
  };

  const showEditModal = (data: any) => {
    const formData = {
      id: data.id,
      Name: data.Name,
      CoverAmount: data.CoverAmount,
      Premium: data.Premium,
      UnderwritingFee: data.UnderwritingFee,
    };

    setAddon(formData);
    setShow(!show);
    setUpdate(true);
  };

  const fetchActive = async (params = {}) => {
    try {
      //   const active = addons.filter((item: any) => item.StatusID === 1);

      const source = filtered.length > 0 ? filtered : addons;
      const activeItems = source.filter((item: any) => item.StatusID === 1);
      if (filtered.length > 0) {
        setFilteredActive(activeItems);
      } else {
        setFilteredActive([]);
      }

      const pagination = state.pagination;
      pagination.total = activeItems.length;

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });

      setActive(filtered.length > 0 ? filtered : addons);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchInActive = async (params = {}) => {
    try {
      const source = filtered.length > 0 ? filtered : addons;
      const inactive = source.filter((item: any) => item.StatusID === 2);
      if (filtered.length > 0) {
        setFilteredInActive(inactive);
      } else {
        setFilteredInActive([]);
      }

      const pagination = state.pagination;
      pagination.total = inactive.length;

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });
      setInactive(inactive);
    } catch (err) {
      console.log(err);
    }
  };

  const onSearch = async (e: any) => {
    const value = e.target.value;
    if (value !== "") {
      const result = await searchAddonsApi(String(groupId), value);
      const addonIds = new Set(addons.map((a: any) => a.id));
      setFiltered(result.data.filter((a: any) => addonIds.has(a.id)));
    } else {
      setFiltered([]);
    }
  };

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    const pager = { ...state.pagination };
    pager.current = pagination.current;
    setState({
      ...state,
      pagination: pager,
    });

    const params = {
      pageSize: pagination.pageSize,
      page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    };

    fetchActive(params);
  };

  useEffect(() => {
    fetchActive();
    fetchInActive();
  }, [addons, filtered]);

  const columns = [
    {
      title: "Addon Name",
      dataIndex: "Name",
      sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Cover Amount",
      dataIndex: "CoverAmount",
    },
    {
      title: "Addon Premium",
      dataIndex: "Premium",
    },
    {
      title: "Underwriting Fee",
      dataIndex: "UnderwritingFee",
    },
    {
      dataIndex: "Action",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Tooltip title="Edit Addon">
            <EditOutlined
              onClick={() => showEditModal(record)}
              style={{ color: "blue" }}
            />
          </Tooltip>
          {/* {state.activeKey === "2" ? (
            <Tooltip title="Activate Product">
              <CheckOutlined
                onClick={() => handleDelete(record.id, state.activeKey)}
                style={{ color: "orange" }}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Remove Product">
              <DeleteOutlined
                onClick={() => handleDelete(record.id, state.activeKey)}
                style={{ color: "red" }}
              />
            </Tooltip>
          )} */}
          {/* <Tooltip title="Remove Product">
            <DeleteOutlined
              onClick={() => handleDelete(record.id)}
              style={{ color: "red" }}
            />
          </Tooltip> */}
          {/* <Switch
            size="small"
            defaultChecked
            onChange={() => onChange(record.id)}
          /> */}
        </Space>
      ),
    },
  ];

  const tabPanes = [
    {
      key: "1",
      title: "Active",
      content: (
        <DataTable
          persistKey="addons"
          dataSource={filteredActive.length > 0 ? filteredActive : active}
          columns={columns}
          loading={state.loading}
          pagination={state.pagination}
          onChange={handleTableChange}
        />
      ),
      count: filteredActive.length > 0 ? filteredActive.length : active.length,
    },
    {
      key: "2",
      title: "Inactive",
      content: (
        <DataTable
          persistKey="addons"
          dataSource={filteredInActive.length > 0 ? filteredInActive : inactive}
          columns={columns}
          loading={state.loading}
          pagination={state.pagination}
          onChange={handleTableChange}
        />
      ),
      count: filteredInActive.length > 0 ? filteredInActive.length : inactive.length,
    },
  ];

  const changeTab = (key: any) => {
    setState({
      ...state,
      activeKey: key,
      loading: false,
    });
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <div className="interactions">
            <Button
              onClick={showModal}
              size="large"
              style={{ marginBottom: "12px" }}
            >
              <PlusOutlined style={{ paddingRight: "5px" }} />
              Add Addon
            </Button>

            <div>
              <Search
                placeholder="Search"
                size="large"
                onChange={(e) => onSearch(e)}
                style={{ width: "100%", margin: "24px 0" }}
              />
            </div>
          </div>
          <Tabs
            type="card"
            defaultActiveKey={state.activeKey}
            activeKey={state.activeKey}
            onChange={changeTab}
          >
            {tabPanes.map((pane) => (
              <TabPane
                key={pane.key}
                tab={
                  <>
                    <span>{pane.title}</span>
                    <span
                      style={{
                        color: "#B0B0B0",
                        fontWeight: "300",
                        marginLeft: "3px",
                        fontSize: "12px",
                      }}
                    >
                      ({pane.count})
                    </span>
                  </>
                }
              >
                {pane.content}
              </TabPane>
            ))}
          </Tabs>

          {update ? (
            <EditAddonModal
              show={show}
              addon={addon}
              showModal={showModal}
              handleUpdate={handleUpdate}
            />
          ) : (
            <AddAddonModal
              show={show}
              showModal={showModal}
              groupId={groupId}
              handleAdd={handleAdd}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default AddonTable;
